var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.v=='login')?_c('div',{staticStyle:{"height":"100%"}},[_c('router-view')],1):_vm._e(),(_vm.v==null)?_c('div',[_c('myhead',{attrs:{"router":_vm.router}}),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }